import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { getFilingConductorAnalysisScopePath } from './filing-conductor-analysis-paths';
import {
  FilingConductorAnalysisLookupResponse,
  UseFilingConductorAnalysisSessionParams,
} from './types';

export function useFilingConductorAnalysisSession({
  corporationId,
  scope,
}: UseFilingConductorAnalysisSessionParams) {
  const path =
    corporationId && scope
      ? getFilingConductorAnalysisScopePath(corporationId, scope)
      : null;

  const { data, error, isLoading, mutate } =
    useSWR<FilingConductorAnalysisLookupResponse>(
      path,
      SWRFetcher({ method: 'GET' }),
      { revalidateOnFocus: false, revalidateIfStale: false }
    );

  return {
    analysis: data?.analysis ?? null,
    isLoading,
    error,
    mutate,
  };
}
``;
